import { useMe } from '@/shared/hooks/useMe'
import { useQuery } from '@tanstack/react-query'
import { resolveApiUrl } from '@/shared/utils/requestsUtils'
import { GetCompanyConfigAttributes } from '../companyConfigServices'
import { requestService } from '@/shared/services/requestServices'

export const useCompanyConfig = () => {
    const { companyId } = useMe()

    return useQuery({
        queryKey: ['company-config', companyId],
        queryFn: () => {
            const url = resolveApiUrl('internal.getCompanyConfig', { variables: { companyId } })
            return requestService<GetCompanyConfigAttributes>(url)
        }
    })
}
